/* SpawnAnything — troop chips of one side (mixed armies, user decision 02.10.2026: one total + shares).
   Up to MAX_TROOPS chips ("Ritter 60 %"), "+ Truppe", and a share bar whose dividers can be dragged. The selected chip
   is the troop the side's unit controls (type, weapon, size …) edit. DOM only: main.js owns the troop list. */
import './troops.css';
import { MAX_TROOPS } from '../game/groups.js';

const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
export const SHARE_MIN = 5; // %

/** Integer counts for `total` units split by shares (largest remainder, every troop keeps at least one unit if possible). */
export function splitCount(total, shares) {
  const sum = shares.reduce((a, b) => a + b, 0) || 1, raw = shares.map(s => total * s / sum), out = raw.map(Math.floor);
  let rest = total - out.reduce((a, b) => a + b, 0);
  raw.map((r, k) => [r - out[k], k]).sort((a, b) => b[0] - a[0] || a[1] - b[1]).forEach(([, k]) => { if (rest > 0) { out[k]++; rest--; } });
  for (let k = 0; k < out.length; k++) if (!out[k] && total >= out.length) { const j = out.indexOf(Math.max(...out)); out[j]--; out[k]++; }
  return out;
}
/** Shares (sum 100) after adding one troop: the newcomer gets an equal part, the others shrink proportionally. */
export function sharesWithNew(shares) {
  const n = shares.length + 1, add = Math.round(100 / n), k = (100 - add) / 100;
  const out = shares.map(s => Math.max(SHARE_MIN, Math.round(s * k)));
  out.push(100 - out.reduce((a, b) => a + b, 0));
  return out;
}
/** Shares after removing troop k: its part goes to the others proportionally. */
export function sharesWithout(shares, k) {
  const rest = shares.filter((_, j) => j !== k), sum = rest.reduce((a, b) => a + b, 0) || 1;
  const out = rest.map(s => Math.round(s * 100 / sum)); if (out.length) out[out.length - 1] += 100 - out.reduce((a, b) => a + b, 0);
  return out;
}

/**
 * root: container element; o = { team, name: troop => label, onSelect(k), onAdd(), onRemove(k), onShares(shares, done) }
 */
export function createTroopUI(root, o) {
  root.classList.add('troops', 't' + o.team);
  let list = [], sel = 0, drag = null;
  root.addEventListener('click', e => {
    if (drag) return;
    const del = e.target.closest('[data-del]'); if (del) { e.stopPropagation(); o.onRemove(+del.dataset.del); return; }
    if (e.target.closest('[data-add]')) { o.onAdd(); return; }
    const c = e.target.closest('[data-k]'); if (c) o.onSelect(+c.dataset.k);
  });
  // dragging a divider moves the border between troop k and k + 1
  root.addEventListener('pointerdown', e => {
    const d = e.target.closest('[data-div]'); if (!d) return;
    e.preventDefault(); d.setPointerCapture(e.pointerId);
    drag = { k: +d.dataset.div, bar: root.querySelector('.troop-bar').getBoundingClientRect(), shares: list.map(t => t.share), el: d };
  });
  root.addEventListener('pointermove', e => {
    if (!drag) return;
    const { k, bar, shares } = drag, before = shares.slice(0, k).reduce((a, b) => a + b, 0), pair = shares[k] + shares[k + 1];
    const at = Math.round(((e.clientX - bar.left) / bar.width) * 100);
    const a = Math.max(SHARE_MIN, Math.min(pair - SHARE_MIN, at - before));
    shares[k] = a; shares[k + 1] = pair - a;
    paintBar(shares); o.onShares(shares.slice(), false);
  });
  const end = () => { if (!drag) return; const s = drag.shares.slice(); drag = null; o.onShares(s, true); };
  root.addEventListener('pointerup', end); root.addEventListener('pointercancel', end);

  function paintBar(shares) {
    root.querySelectorAll('.troop-seg').forEach((el, k) => { el.style.flexGrow = shares[k]; });
    root.querySelectorAll('[data-pct]').forEach(el => { el.textContent = shares[+el.dataset.pct] + ' %'; });
  }
  function render(troops, selected) {
    list = troops; sel = selected;
    const many = list.length > 1;
    root.innerHTML = `<div class="troop-chips" role="group" aria-label="Truppen">${list.map((t, k) => `<button type="button" class="troop" data-k="${k}" aria-pressed="${k === sel}" title="Diese Truppe bearbeiten">
        <b>${esc(o.name(t))}</b>${many ? `<span data-pct="${k}">${t.share} %</span><i class="ti ti-x" data-del="${k}" role="button" aria-label="${esc(o.name(t))} entfernen" title="Truppe entfernen"></i>` : ''}</button>`).join('')}${list.length < MAX_TROOPS ? '<button type="button" class="troop-add" data-add title="Weitere Einheitenart in diese Armee (bis 4)"><i class="ti ti-plus" aria-hidden="true"></i> Truppe</button>' : ''}</div>
      ${many ? `<div class="troop-bar" aria-label="Anteile">${list.map((t, k) => `<span class="troop-seg${k === sel ? ' on' : ''}" style="flex-grow:${t.share}"></span>${k < list.length - 1 ? `<span class="troop-div" data-div="${k}" role="separator" aria-label="Anteil verschieben" tabindex="0"></span>` : ''}`).join('')}</div>` : ''}`;
  }
  return { render };
}
